import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})

export class SeguroAdesaoServices {

  constructor(private http: HttpClient){}

  public idadeParticipante():Observable<any>{
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/IdadeParticipante`)
  }

  public fatoresDeCalculo(idade: number = 0):Observable<any>{
    return this.http
                .get(`${environment.apiURL}/Aberto/Simulador/FatoresSimSeguro`, {params: {idade: idade} as any})
  }

  public ElegibilidadeAdesao():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/ElegibilidadeAdesao`)
  }

  public CoberturaDisponivel():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/CoberturaDisponivel`)
  }

  public ListarOcupacao():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/ListarOcupacao`)
  }

  public SalvarSimulacao(dados: any):Observable<any> {
    return this.http
                .post(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/SalvarSimulacao`, dados)
  }

  public CarregarSimulacao():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/CarregarSimulacao`)
  }

  public SalvarDeclaracaoDeSaude(dados: any):Observable<any> {
    return this.http
                .post(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/SalvarDeclaracaoDeSaude`, dados)
  }

  public CarregarDeclaracaoDeSaude():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/CarregarDeclaracaoDeSaude`)
  }

  public BaixarProposta():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/BaixarProposta`, {responseType: "blob"})
  }

  public CarregarResumoAdesao():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/ResumoAdesao`)
  }

  public FinalizarAdesao(dados: any):Observable<any> {
    return this.http
                .post(`${environment.apiURL}/Logado/Seguro/AdesaoSeguro/FinalizarAdesao`, dados)
  }

}